<template>
  <el-dialog
    :title="$t('企业联系人列表')"
    :visible.sync="dialogVisible"
    append-to-body
    custom-class="dialog-kf-pc"
  >
    <div class="kf-img-pc">
      <div>
        <span>{{
          $t('洽谈仅对认证展、客商的咨询顾问和商务代表开放，您无访问权限。')
        }}</span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  created() {},
  methods: {
    open() {
      this.dialogVisible = true
    }
  }
}
</script>
